import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { TranslateModule } from '@ngx-translate/core';
import { NgrxFormsModule } from 'ngrx-forms';
import { NgrxFormsExtensionsModule } from '@app/common/ngrx-forms-extensions';
import { FormsModule } from '@app/common/forms';
import { PriceOfferRejectFormComponent } from './price-offer-reject-form.component';

@NgModule({
  declarations: [ PriceOfferRejectFormComponent ],
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    TranslateModule.forChild(),
    NgrxFormsModule,
    NgrxFormsExtensionsModule,
    FormsModule
  ],
  exports: [ PriceOfferRejectFormComponent ]
})
export class PriceOfferRejectFormModule {

}
